import { IFactoryLoadingPlan } from "./types";
import request from "@/utils/request";

export const defaultFactoryLoadingPlanData: IFactoryLoadingPlan = {
  id: null,
  code: null,
  customerId: null,
  customerAbbr: null,
  shippingOrderId: null,
  shippingOrderCode: null,
  state: null,
  remark: null,
  createdAt: null,
  containerTypeInfos: [],
  unreleasedContainerTypeQuantity: null,
  logisticsClerkId: null,
  logisticsClerkName: null,
  estimatedSailingSchedule: null,
  billOfLadingCode: null,
  combinedContainer: null,
  sellerId: null,
  bookingOrderCodes: null,
  companyCode: null,
  declaration: null
};

export const createFactoryLoadingPlan = (data: any) =>
  request({
    url: `/factory-loading-plans`,
    method: "post",
    data
  });

export const updateFactoryLoadingPlan = (id: string, data: any) =>
  request({
    url: `/factory-loading-plans/${id}`,
    method: "put",
    data
  });

export const getFactoryLoadingPlans = (params: any) =>
  request({
    url: "/factory-loading-plans",
    method: "get",
    params
  });

export const addFactoryLoadingPlanShippingOrder = (id: string, data: any) =>
  request({
    url: `/factory-loading-plans/${id}/shipping-order`,
    method: "put",
    data
  });

export const searchFactoryLoadingPlanContainerTypes = (id: string) =>
  request({
    url: `/factory-loading-plans/${id}/container-types`,
    method: "get"
  });

export const releaseContainerTypes = (id: string, data: any) =>
  request({
    url: `/factory-loading-plans/${id}/container-types`,
    method: "post",
    data
  });

export const deleteContainerType = (id: string, containerTypeId: string) =>
  request({
    url: `/factory-loading-plans/${id}/container-types/${containerTypeId}`,
    method: "delete"
  });

export const getFactoryLoadingPlan = (id: string) =>
  request({
    url: `/factory-loading-plans/${id}`,
    method: "get"
  });


export const releaseContainerType = (factoryLoadingPlanId: string, data: { containerTypes: any }) =>
  request({
    url: `/factory-loading-plans/${factoryLoadingPlanId}/container-types`,
    method: "POST",
    data
  });

export const searchHqPackingList = (
  factoryLoadingPlanId: string,
  params: {
    hqPackingListCode: string | null;
    factoryName: string | null;
    containerNumberKeyword?: string | null;
  }
) =>
  request({
    url: `/factory-loading-plans/${factoryLoadingPlanId}/customs-packing-set`,
    method: "GET",
    params
  });

export const configContainers = (factoryLoadingPlanId: string, data: any) =>
  request({
    url: `/factory-loading-plans/${factoryLoadingPlanId}/container-configuration`,
    method: "POST",
    data: { containerTypeList: data }
  });

export const completeContainerConfiguration = (factoryLoadingPlanId: string) =>
  request({
    url: `/factory-loading-plans/${factoryLoadingPlanId}/container-configuration-state`,
    method: "PUT"
  });

export const removeConfiguredContainer = (factoryLoadingPlanId: string, customsPackingIds: string[]) =>
  request({
    url: `/factory-loading-plans/${factoryLoadingPlanId}/container-configuration`,
    method: "DELETE",
    data: { customsPackingIds }
  });

export const removeFactoryLoadingPlan = (factoryLoadingPlanId: string) =>
    request({
        url: `/factory-loading-plans/${factoryLoadingPlanId}`,
        method: "DELETE"
    });

export const updateFactoryLoadingPlanStateToShipment = (factoryLoadingPlanId: string,params) =>
    request({
        url: `/factory-loading-plans/${factoryLoadingPlanId}/shipment`,
        method: "PUT",
        params
    });

export const getFactoryLoadingPlanStates = () =>
    request({
        url: "/factory-loading-plan-states",
        method: "GET"
    });
